// extracted by mini-css-extract-plugin
export default {"container":"ChooseUs_container__93Sit","h1":"ChooseUs_h1__5Hii2"};